import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useOrganization } from '@/hooks/useOrganizations';
import { useDialog } from '@/providers/DialogProvider';
import { Trash } from '@mynaui/icons-react';
import { FunctionComponent } from 'react';
import { DeleteOrganizationDialog } from './DeleteOrganizationDialog';

export const OrganizationDangerZone: FunctionComponent = () => {
  const { openDialog } = useDialog();
  const organization = useOrganization();

  if (!organization) return null;

  return (
    <Card className='border-rose-200'>
      <CardHeader className='border-rose-200 bg-rose-50/40'>
        <CardTitle className='text-rose-600'>Danger Zone</CardTitle>
        <CardDescription className='text-rose-600/70'>Permanent actions that cannot be undone.</CardDescription>
      </CardHeader>
      <CardContent>
        <div className='flex items-center justify-between overflow-hidden'>
          <div className='flex flex-col gap-1'>
            <h3 className='font-medium leading-none text-slate-900 dark:text-white'>Delete Organization</h3>
            <p className='text-sm font-medium leading-none text-slate-500 dark:text-white/70 whitespace-normal'>
              Permanently delete this organization and all its projects, data, and files.
            </p>
          </div>
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <Button variant='destructive'>
                <Trash className='h-4 w-4 mr-2 stroke-2' />
                Delete Organization
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
                <AlertDialogDescription>
                  This action cannot be undone. This will permanently delete the organization{' '}
                  <span className='font-semibold'>{organization.name}</span> and remove all its data from our servers.
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>Cancel</AlertDialogCancel>
                <AlertDialogAction
                  onClick={() =>
                    openDialog(
                      <DeleteOrganizationDialog
                        organizationId={organization.id}
                        organizationName={organization.name}
                      />,
                    )
                  }
                  variant='destructive'>
                  Delete Organization
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      </CardContent>
    </Card>
  );
};
